var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.GetImageStyle())},[_c('v-badge',{attrs:{"content":_vm.count,"value":_vm.count > 0,"left":"","color":_vm.GetBadgeColor(),"offset-x":"25"}},[_c('v-img',{attrs:{"src":_vm.src,"width":_vm.size},on:{"mousedown":_vm.OnPolinaClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }